import { SummaryConfig } from "../../../hooks";

export const cairsGradingSummaryConfig: SummaryConfig = {
    graft: [
        {
            accessor: "graft.ringSize",
            formatter: (val) => `Ring size: ${val} mm.`,
        },
        {
            accessor: "graft.ringSegmentCount",
            formatter: (val) => `Number of ring segments: ${val}.`,
        },
        {
            accessor: "graft.visibleRemains",
            formatter: (val) =>
                val ? "Visible epithelial/endothelial remains noted." : "No visible epithelial/endothelial remains.",
        },
        {
            accessor: "graft.damageVisible",
            formatter: (val) => (val ? "Ring damage visible." : "No ring damage visible."),
        },
        {
            accessor: "graft.comments",
        },
    ],
};
